import { getConnectionCookie } from 'portal-sdk';

declare global {
  interface Window {
    mockCloud?: boolean;
    mockOnPremise?: boolean;
  }
}

/**
 * returns true if the `stardogConnection` cookie exists
 *
 * This cookie comes from Portal/Cloud only and so we can use it
 * to determine if we are inside a cloud setup.
 */
export const isPortal = (): boolean => {
  const cookie = getConnectionCookie();

  return Boolean(cookie);
};

/**
 * returns true if the app is being accessed from `cloud.stardog.com`
 *
 * This can be mocked by setting `window.mockCloud = true`
 */
export const isCloud = () => {
  const cookie = getConnectionCookie();
  return Boolean(window.mockCloud || cookie?.isPortal);
};
/**
 * returns true if the app is being accessed from a portal connection but not `cloud.stardog.com`
 *
 * This can be mocked by setting `window.mockOnPremise = true`
 */
export const isOnPremise = () => {
  const cookie = getConnectionCookie();
  return Boolean(window.mockOnPremise || cookie?.isLaunchpad);
};
